import { apiGeneral } from './_General';

export const apiListPrimaryQuizQuestions = {
  getQuizQuestions(cb, eCb) {
    apiGeneral.apiFetch('public/list_primary_quiz_questions', {
      $orderby: 'question_number'
    }, null, cb, eCb);
  }
};
